import { render, staticRenderFns } from "./reportPrePayFeeOrder.vue?vue&type=template&id=56d71000&scoped=true"
import script from "./reportPrePayFeeOrder.vue?vue&type=script&lang=js"
export * from "./reportPrePayFeeOrder.vue?vue&type=script&lang=js"
import style0 from "./reportPrePayFeeOrder.vue?vue&type=style&index=0&id=56d71000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d71000",
  null
  
)

export default component.exports